module.exports = __webpack_public_path__ + "static/media/map_pin_int_gray_shared.3203e063.svg";